<template>
  <div class="card">
    <h5 class="card-header">SSO Configuration</h5>
    <div class="card-body">
      <div v-if="loading" class="text-center py-4">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="ml-2">Loading...</span>
      </div>

      <div v-else>
        <div class="mb-4">
          <h6>SSO Status</h6>
          <div v-if="ssoEnabled" class="alert alert-success mb-0">
            <fa icon="check-circle" class="mr-2" />
            SSO is configured and enabled for this organization.
          </div>
          <div v-else class="alert alert-secondary mb-0">
            <fa icon="info-circle" class="mr-2" />
            SSO is not configured for this organization.
          </div>
        </div>

        <ErrorSummary :error="error" />

        <p class="text-muted">
          Click the button below to open the SSO configuration portal. You will be redirected to WorkOS to configure your identity provider settings.
        </p>

        <button type="button" class="btn btn-primary" :disabled="configuring" @click="configureSso">
          <span v-if="configuring" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
          {{ ssoEnabled ? "Manage SSO" : "Configure SSO" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    ErrorSummary,
  },
  props: {
    organizationId: String,
  },
  data() {
    return {
      loading: true,
      configuring: false,
      error: null,
      ssoConfigs: [],
    };
  },
  computed: {
    ssoEnabled() {
      return this.ssoConfigs.some(config => config.status === "enabled");
    },
  },
  created() {
    this.loadSsoStatus();
  },
  watch: {
    organizationId() {
      this.loadSsoStatus();
    },
  },
  methods: {
    loadSsoStatus() {
      this.loading = true;
      this.error = null;
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/sso-config`)
        .then(res => {
          this.ssoConfigs = res.data;
        })
        .catch(err => {
          this.error = err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    configureSso() {
      this.configuring = true;
      this.error = null;

      const returnUrl = `${window.location.origin}/settings/sso/complete?organizationId=${this.organizationId}`;

      this.$axios
        .post(`/v1/organizations/${this.organizationId}/sso/setup`, { returnUrl })
        .then(res => {
          window.location.href = res.data.portalLink;
        })
        .catch(err => {
          this.error = err;
          this.configuring = false;
        });
    },
  },
};
</script>
